module.exports = "<span> {{ option.field.farm_name }} {{ option.field.field_name }} - {{ option.field.acres }}</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/selector/item-default.html
// module id = 578
// module chunks = 0